<template>
    <div class="loading large">
        <i class="fa fa-refresh fa-spin"></i>
        <p>Saving</p>
    </div>
</template>

<script>
    export default {
        name: 'SavingLarge'
    }
</script>


// WEBPACK FOOTER //
// SavingLarge.vue?0f8b5722